"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: "MenuItem",
  functional: true,
  props: {
    icon: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  render: function render(h, context) {
    var _context$props = context.props,
      icon = _context$props.icon,
      title = _context$props.title;
    var vnodes = [];
    if (icon) {
      // vnodes.push(<svg-icon icon-class={icon}/>)
      vnodes.push(h("i", {
        "class": 'iconfont ppap ' + icon
      }));
    }
    if (title) {
      vnodes.push(h("span", {
        "slot": "title"
      }, [title]));
    }
    return vnodes;
  }
};